import { API_URL } from "./Config";
import { formatDate, formatDateForFiltering } from "./DateUtils";

/*
    "licence_id": "24c8e87d-7c61-e211-9eb5-0050568a69e2",
    "reg_no": "P0815-02",
    "licenceprofile_id": "373122fb-8a6d-4f9c-bef1-142252f47d33",
    "licence_type": "Industrial Emissions",
    "licence_name": "Lacpatrick Dairies Limited",
    "date_of_licence": "2013-03-25T00:00:00",
    "ceased_date": null,
    "licence_status": "Licensed",
    "licence_substatus": "Licensable Activity Commenced",
    "licence_application_status": "Replaced",
    "licenceprofile_number": "P0815",
    "urban_areape": null
*/

export interface ILicenceDetails {
  licence_id: string;
  reg_no: string;
  licenceprofile_id: string;
  licence_type: string;
  date_of_licence: string;
  ceased_date: string;
  licence_status: string;
  licence_substatus: string;
  licence_application_status: string;
  licenceprofile_number: string;
  urban_areape: string;
}

export async function GetLicenseDetailsAsync(
  licenceId: string
): Promise<ILicenceDetails> {
  var url = `${API_URL}/Licence/byid?licence_id=${licenceId}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/licence-details`;
  }

  var response = await fetch(url);
  var body = <ILicenceDetails>await response.json();

  return <ILicenceDetails>{
    licence_id: body.licence_id,
    reg_no: body.reg_no,
    licenceprofile_id: body.licenceprofile_id,
    licence_type: body.licence_type,
    date_of_licence: formatDate(body.date_of_licence),
    ceased_date: formatDate(body.ceased_date),
    licence_status: body.licence_status,
    licence_substatus: body.licence_substatus,
    licence_application_status: body.licence_application_status,
    licenceprofile_number: body.licenceprofile_number,
    urban_areape: body.urban_areape,
  };
}
